import Vue from "vue";

export default {
  /**
   * Save Room Messages to the store
   * @param state {Object}
   * @param messages {Array}
   */
  setRoomMessages(state, { messages }) {
    state.roomMessages = messages;
  },

  /**
   * Save Table Messages to the store
   * @param state {Object}
   * @param messages {Array}
   */
  setTableMessages(state, { messages }) {
    state.tableMessages = messages;
  },

  changeChatMode(state, { mode, scrollPage }) {
    state.chatMode = mode;
    if (scrollPage && mode === "PRIVATE") {
      let chatsElement = document.getElementById("people-chat-container");
      chatsElement.scrollIntoView({ behavior: "smooth" });
    }
  },

  setPrivateChatTarget(state, privateChatTarget) {
    state.privateChatTarget = privateChatTarget;
  },

  setUserPrivateMessages(state, data) {
    state.privateMessages = data;
  },

  setUserPrivateUsers(state, data) {
    state.privateChatTargetUsers = data;
  },

  addUserPrivateUser(state, data) {
    let existingUser = state.privateChatTargetUsers.find(u => u.userUUID === data.userUUID);
    if (!existingUser) {
      state.privateChatTargetUsers.push(data);
    }
  },

  /**
   * Update private chat filter
   * @param state {Object}
   * @param type {String}
   * @param value {Boolean}
   */
  updatePrivateChatFilters(state, { type, value }) {
    state.privateChatFilters[type] = value;
  },

  /**
   * Reset unread messages counter
   * @param state {Objects}
   * @param type {String} -  TABLE or PRIVATE
   */
  resetUnreadMessagesCounter(state, type) {
    state.unreadMessagesCounter[type] = 0;
  },

  /**
   * Update room message
   * @param state {Objects}
   * @param updatedMessage {Object}
   */
  updateRoomMessage(state, updatedMessage) {
    let message = state.roomMessages.find(m => m.messageUUID === updatedMessage.messageUUID);
    Vue.set(message, "messageStatus", updatedMessage.messageStatus);
  }
};
